import onQuickOptionToggle from 'owa-options-actions/lib/onQuickOptionToggle';
import { orchestrator } from 'satcheljs';
import { logUsage } from 'owa-analytics';
import { OptionQuickToggleProps } from 'owa-options-core';

const QUICK_SETTINGS_TOGGLE_USAGE_KEY = 'quickSettingsToggle';

export default orchestrator(onQuickOptionToggle, actionMessage => {
    let { isToggledOn, quickOptionSetting, key } = actionMessage;
    logUsage(QUICK_SETTINGS_TOGGLE_USAGE_KEY, {
        quickOptionKey: key,
        isToggledOn: `${isToggledOn}`,
    });

    const { onToggle } = quickOptionSetting.rendering as OptionQuickToggleProps;
    if (onToggle) {
        onToggle(isToggledOn);
    }
});

export { OptionQuickComponentSettings } from 'owa-options-core';
